<div class="pagination-container">
  <div class="paginator">
    <span>{{ paginatorFromAPi.from }} – {{ paginatorFromAPi.to }} of {{ paginatorFromAPi.total }}</span>
    <button class="pagination-button"
            [matTooltip]="'First Page' | translate"
            (click)="handleGoToFirstPage()"
            [disabled]="paginatorFromAPi.current_page === 1">
      <mat-icon>first_page</mat-icon>
    </button>
    <button class="pagination-button"
            [matTooltip]="'Previous Page' | translate"
            (click)="handleGoToPreviousPage()"
            [disabled]="paginatorFromAPi.current_page === 1">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button class="pagination-button"
            [matTooltip]="'Next Page' | translate"
            (click)="handleGoToNextPage()"
            [disabled]="paginatorFromAPi.current_page === paginatorFromAPi.last_page">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <button class="pagination-button"
            [matTooltip]="'Last Page' | translate"
            (click)="handleGoToLastPage()"
            [disabled]="paginatorFromAPi.current_page === paginatorFromAPi.last_page">
      <mat-icon>last_page</mat-icon>
    </button>
  </div>

</div>
